"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventTypes = exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["Graduation"] = "Graduation";
    EventType["Speeches"] = "Speeches";
    EventType["TestEvent"] = "Test event";
    EventType["VirtualGraduation"] = "Virtual Graduation";
    EventType["HybridClipsOnlyEvent"] = "Hybrid Clips Only Graduation";
    EventType["HybridFullCeremonyEvent"] = "Hybrid Full Ceremony Graduation";
    EventType["LiveEvent"] = "Live Event Graduation";
    EventType["NameReading"] = "Name Reading";
})(EventType = exports.EventType || (exports.EventType = {}));
exports.eventTypes = Object.keys(EventType).map(key => EventType[key]);
//# sourceMappingURL=event-type.js.map